import { Box, Link, Stack } from '@mui/material';
import { HiddenMessageTypo } from 'components';
import { useProduct } from 'stores';
import { Swiper, SwiperSlide } from 'swiper/react';
import { HiddenMessageProps } from 'types';
import './index.css';

const HiddenProductInfo = () => {
	const product = useProduct();
	// const uaidType = product?.uaidType;
	const hiddenProductInfoList: Array<HiddenMessageProps> =
		product?.hiddenProductInfoList;

	// if (uaidType !== 2) return <></>;
	if (!hiddenProductInfoList || !hiddenProductInfoList.length) return <></>;

	return (
		<>
			<Box pl={2} pr={2}>
				<Swiper
					className="hidden-info-swiper-component"
					pagination={{ clickable: false }}
					loop={true}
				>
					{hiddenProductInfoList.map((object, index) => (
						<SwiperSlide key={index}>
							<Stack>
								<Box width="100%" height="104px">
									{object.image ? (
										<Link
											href={object.imageLink}
											target={'_blank'}
										>
											<Box
												component="img"
												sx={{
													width: '100%',
													maxHeight: '104px',
													objectFit: 'cover',
												}}
												alt="image"
												src={`${process.env.REACT_APP_DOMAIN_NAME}${process.env.REACT_APP_API_GET_IMAGE}?name=${object['image']}`}
											/>
										</Link>
									) : null}
								</Box>
								<HiddenMessageTypo {...object} />
							</Stack>
						</SwiperSlide>
					))}
				</Swiper>
			</Box>
		</>
	);
};

export default HiddenProductInfo;
